import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation Delete($id: Int!) {
    deleteAdmissionWay(id: $id) {
      id
    }
  }
`);

export const responseDeleteKey = "deleteAdmissionWay";
export interface DeleteGql {
  deleteAdmissionWay: {
    id?: number;
  };
}
